"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAndValidateRequestedAnalysis = void 0;
const schemas_1 = require("./schemas");
const parseAndValidateRequestedAnalysis = (res) => {
    if (!res) {
        return null;
    }
    return schemas_1.RequestedAnalysisSchema.parse({ ...res, response: JSON.parse(res.response) });
};
exports.parseAndValidateRequestedAnalysis = parseAndValidateRequestedAnalysis;
//# sourceMappingURL=helpers.js.map